module.exports = __webpack_public_path__ + "static/img/3.4be0194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/3.png
// module id = /w/7
// module chunks = 0